import React, { useState } from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import mustardBg from "../../img/mustarddreams.png";
import StoreModal from "../../components/StoreModal/StoreModal";
import DijonTickets from "./DijonTickets";
import ActiveTicket from "../Tickets/ActiveTicket";
import DashboardIcons from "./DashboardIcons";
import DijonBeeminder from "./DijonBeeminder"
import DijonRandom from "./DijonRandom"
import DijonFood from "./DijonFood"
import DijonFinance from "./DijonFinance"
import DijonDice from "./DijonDice"
import DijonSchwab from "./DijonSchwab"
import DijonGipirt from "./DijonGipirt"
import DijonVideosCard from "./DijonVideosCard"
import DijonBeaches from "./DijonBeaches"
import DijonCamping from "./DijonCamping"
import DijonBoat from "./DijonBoat"
import DijonLedger from "./DijonLedger"
import DijonCardGame from "./DijonCardGame"
import DijonBackgammon from "./DijonBackgammon"
import DijonEmergency from "./DijonEmergency"
import DijonStrategy from "./DijonStrategy"
import DijonOpenBB from "./DijonOpenBB"
import Fitness from "../Fitness/Fitness"
import { useSwipeable } from 'react-swipeable';
import { useSelector } from 'react-redux';

function Dashboard({ activeCards, setActiveCards }) {
  const allowedCards = useSelector(state => state.permissions.allowedCards);
  const hasPermission = (cardKey) => allowedCards.includes(cardKey);
  // Declare a new state variable, which we'll call "count"
  const [count, setCount] = useState(0);
  const [fullscreen, setFullscreen] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const goals = [
    { id: 1, title: 'Goal 1', progress: 70, image: 'goal1.jpg' },
    { id: 2, title: 'Goal 2', progress: 45, image: 'goal2.jpg' },
    { id: 3, title: 'Goal 3', progress: 85, image: 'goal3.jpg' },
  ];
  const openImage = (src) => {
    const imgWindow = window.open("", "_blank");
    imgWindow.document.write(`<img src="${src}" alt="Goal Image" style="width:100%">`);
  };


  const handlers = useSwipeable({
    onSwipedLeft: () => console.log("Swiped left!"),
    onSwipedRight: () => console.log("Swiped right!"),
    onSwipedUp: () => console.log("Swiped up!"),
    onSwipedDown: () => console.log("Swiped down!"),
  });


  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <img
        style={{
          width: "100%",
          height: "100vh",
          position: "fixed",
          right: "0",
          top: "40px",
        }}
        src={mustardBg}
      />

      <div style={{ paddingTop: "60px" }}>
        <DashboardIcons
          activeCards={activeCards}
          setActiveCards={setActiveCards}
        />
      </div>
      <div
        style={{
          position: "absolute",
          top: "40px",
          left: 0,
          width: "100%",
          height: "calc(100vh - 40px)",
          zIndex: 1000,
          pointerEvents: "none",
        }}
      >
        <div
          {...handlers}
          style={{ width: "100%", height: "100%", pointerEvents: "none" }}
        >
          <StoreModal
            open={activeCards.fmRadio && hasPermission('fmRadio')}
            onClose={() => setActiveCards({ ...activeCards, fmRadio: false })}
          />
          {activeCards.tickets && !fullscreen && hasPermission('tickets') && (
            <DijonTickets
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.beeminder && !fullscreen && hasPermission('beeminder') && (
            <DijonBeeminder
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.random && !fullscreen && hasPermission('random') && (
            <DijonRandom
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.food && !fullscreen && hasPermission('food') && (
            <DijonFood
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.finance && !fullscreen && hasPermission('finance') && (
            <DijonFinance
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.dice && !fullscreen && hasPermission('dice') && (
            <DijonDice
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.schwab && !fullscreen && hasPermission('schwab') && (
            <DijonSchwab
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.gipirt && !fullscreen && hasPermission('gipirt') && (
            <DijonGipirt
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
              setSelectedTicket={setSelectedTicket}
              selectedTicket={selectedTicket}
            />
          )}
          {activeCards.videos && !fullscreen && hasPermission('videos') && (
            <DijonVideosCard
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.beaches && !fullscreen && hasPermission('beaches') && (
            <DijonBeaches
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.camping && !fullscreen && hasPermission('camping') && (
            <DijonCamping
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.boat && !fullscreen && hasPermission('boat') && (
            <DijonBoat
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.ledger && !fullscreen && hasPermission('ledger') && (
            <DijonLedger
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.cardgame && !fullscreen && hasPermission('cardgame') && (
            <DijonCardGame
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.backgammon && !fullscreen && hasPermission('backgammon') && (
            <DijonBackgammon
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.emergency && !fullscreen && hasPermission('emergency') && (
            <DijonEmergency
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.fitness && !fullscreen && hasPermission('fitness') && (
            <Fitness
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.strategy && !fullscreen && hasPermission('strategy') && (
            <DijonStrategy
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {activeCards.openbb && !fullscreen && hasPermission('openbb') && (
            <DijonOpenBB
              activeCards={activeCards}
              setActiveCards={setActiveCards}
              fullscreen={fullscreen}
              setFullscreen={setFullscreen}
            />
          )}
          {fullscreen == "dijon-tickets" && (
            <ActiveTicket
              setFullscreen={setFullscreen}
              selectedTicket={selectedTicket}
            />
          )}
        </div>
      </div>

      {/* Customer support footer — bottom of the main page. */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 1100,
          textAlign: "center",
          padding: "6px 12px",
          fontSize: "12px",
          color: "#fff",
          background: "rgba(0,0,0,0.55)",
          pointerEvents: "auto",
        }}
      >
        Customer support:{" "}
        <a href="tel:+14014143290" style={{ color: "#ffd23f", fontWeight: 600, textDecoration: "none" }}>
          (401) 414-3290
        </a>
      </div>

    </div>

  );
}

export default Dashboard;
